import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import './css/Lab.css';
import './css/DetailsResultsAnal.css';
import labService from './labService';
import authService from '../auth/authService';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faX } from '@fortawesome/free-solid-svg-icons';
import Visualization from './Visualization.js';
import ClipLoader from "react-spinners/ClipLoader";


const DetailsResultsAnal = ({ isCollapsed, toggleSidebar }) => {
  const { pk } = useParams(); // Extract pk from route parameters
  const [currentUser, setCurrentUser] = useState(null);
  const [analDetails, setAnalDetails] = useState(null);
  const [selectedPredictionIdx, setSelectedPredictionIdx] = useState(0);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [visualizationType, setVisualizationType] = useState('inconclusive');
  const [isDownloading, setIsDownloading] = useState(false);


  const handleGoBack = () => {
    navigate(-1); // This goes back one step in history
  };

  const closeSelectModels = () => {
    navigate('/laboratory');
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => {
    setShowModal(false);
    setIsConfirmed(false); // Reset confirmation checkbox
  };

  const handleDelete = () => {
    if (currentUser && pk && isConfirmed) {
      labService.deleteAnalysis(pk, currentUser.access)
        .then(() => {
          navigate('/laboratory/');
        })
        .catch(error => console.error(error))
        .finally(() => closeModal());
    }
  };

  useEffect(() => {
    const user = authService.getCurrentUser();
    setCurrentUser(user);
  }, []);

  useEffect(() => {
    if (currentUser && pk) {
      labService.getAnalysisDetail(pk, currentUser.access)
        .then(response => {
          setAnalDetails(response.data);
          setVisualizationType(response.data.visualization_type || 'inconclusive');
        })
        .catch(error => console.error(error));
    }
  }, [currentUser, pk]);


  const handlePredictionClick = (idx) => {
    if (idx === selectedPredictionIdx) {
      return; // Do nothing if the current item is clicked
    }
    setSelectedPredictionIdx(idx); // Set the selected prediction index
  };

  function formatClassNotation(predictionResult, classNotations) {
    if (!classNotations) return predictionResult;

    // If backend sends string like "{'0': 'Label', '1': 'Label'}"
    if (typeof classNotations === "string") {
      try {
        classNotations = JSON.parse(
          classNotations.replace(/'/g, '"')
        );
      } catch (e) {
        console.warn("Failed to parse class_notations:", classNotations);
        return predictionResult;
      }
    }

    const key = String(predictionResult).trim();
    let value = classNotations[key];

    // Handle weird values like: undefined, "", "'", null
    if (!value || value === "'" || value === '"') {
      return predictionResult;
    }

    return value;
  }

  function getClassColor(prediction) {
    let classNotations;
    if (typeof prediction.class_notations === "string") {
      try {
        classNotations = JSON.parse(prediction.class_notations.replace(/'/g, '"'));
      } catch (e) {
        classNotations = {};
      }
    } else {
      classNotations = prediction.class_notations || {};
    }

    const numClasses = Object.keys(classNotations).length;

    if (numClasses === 2) {
      // Only two classes → color based on result
      return prediction.prediction_result === 1 ? "#b34a00" : "#1b4581";
    }

    // 3 or more classes → default color
    return "#1b4581";
  }



  const handleDownload = () => {
    if (currentUser && pk) {
      setIsDownloading(true); // 1. Włączamy loader

      labService.getPredictionReport(pk, currentUser.access)
        .then((response) => {
          // Create a blob URL for the file
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `prediction_report_${pk}.zip`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          console.error("Error downloading report:", error);
          // Opcjonalnie: Tutaj możesz dodać alert/toast z błędem dla użytkownika
        })
        .finally(() => {
          setIsDownloading(false); // 2. Wyłączamy loader niezależnie od wyniku
        });
    }
  }


  return (
    <div className='lab-container'>
      <Navbar />
      <div className='lab-side-content'>
        <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
        <div className='anal-details-container'>
          <div className='np-tabs'>
            <div className='x'>
              <button onClick={closeSelectModels} className='x-but'>
                <FontAwesomeIcon className='icon-x' icon={faX} />
              </button>
            </div>
            <div className='np-steps dr-tab-1'>
              <p className='p-step'>STEP 1</p>
              <p className='mar-btm-few'>Select endpoints</p>
            </div>
            <div className='np-steps dr-tab-2'>
              <p className='p-step'>STEP 2</p>
              <p className='mar-btm-few'>Define Nanoform</p>
            </div>
            <div className='np-steps dr-tab-3'>
              <p className='p-step'>STEP 3</p>
              <p className='mar-btm-few'>Summary</p>
            </div>
            <div className='np-steps dr-tab-4'>
              <p className='p-step'>STEP 4</p>
              <p className='mar-btm-few'>Results</p>
            </div>

          </div>
          {showModal && (
            <div className="modal">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="trash-icon">
                    <FontAwesomeIcon icon={faTrashCan} size="2x" />
                  </div>
                  <button className="close-button" onClick={closeModal}>
                    ×
                  </button>
                </div>
                <div className='modal-con'>
                  <p className="p-delete">
                    This action will delete all data regarding your prediction.
                    <br />
                    Your tokens <strong>will not be refunded</strong> in this case.
                    <br />
                    Please confirm by checking the box below.
                  </p>

                  <label className='p-delete confirm-txt'>
                    <input
                      type="checkbox"
                      className='delete-check'
                      checked={isConfirmed}
                      onChange={(e) => setIsConfirmed(e.target.checked)}
                    />
                    I confirm that I want to delete this prediction result.
                  </label>
                  <div className="modal-buttons">
                    <button className={`confirm-btn ${isConfirmed ? '' : 'disabled-btn'}`} onClick={handleDelete} disabled={!isConfirmed}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {analDetails ? (
            <div className='function-area'>

              <div className="det-header-content">
                <div className='left-buttons'>
                  <button className="go-back-btn2" onClick={handleGoBack}>
                    Back
                  </button>
                </div>
                <div className="right-buttons" style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                  <button
                    className="down-repo-btn"
                    onClick={handleDownload}
                    disabled={isDownloading}
                    // display: flex wewnątrz przycisku służy tylko do wyrównania napisu i kółeczka
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', minWidth: '160px' }}
                  >
                    {isDownloading ? (
                      <>
                        {/* <span>Processing...</span> */}
                        <ClipLoader color={"#ffffff"} loading={true} size={15} />
                      </>
                    ) : (
                      "Download report"
                    )}
                  </button>
                  <button className="delete-btn" onClick={openModal}>Delete analysis</button>
                </div>
              </div>
              <div className='anal-name-div'>
                <p className='main-text anal-name-sum'>Analysis name:</p>
                <p className='name-anal-sum'>
                  {analDetails ? analDetails.name : 'Loading...'}
                </p>
              </div>

              <div className='details-content'>
                <div className='left-details'>
                  <p className='green-head'>Selected models</p>
                  <div className='endp-btns'>

                    <div className='btns-model-names'>
                      {analDetails.predictions
                        .filter(prediction => prediction.status === 'Done')
                        .map((prediction, idx) => (
                          <button
                            onClick={() => handlePredictionClick(idx)}
                            className={`prediction-name-btn ${selectedPredictionIdx === idx ? 'selected-btn' : ''}`}
                          >
                            {prediction.model_name} - {prediction.cell_line_name}
                          </button>
                        ))}
                    </div>
                  </div>
                  {analDetails.predictions
                    .filter(prediction => prediction.status === 'Done')
                    .map((prediction, idx) => (
                      selectedPredictionIdx === idx && (
                        <div key={idx} className="lower-left-det">
                          <div className="left-lower-left-det">
                            <p className="green-head">Endpoints details</p>
                            <div className="det-box">
                              <p className='grey-uppercase'>Dependent variable</p>

                              {prediction.algorithm_type === "READ_ACROSS_nQTb" ? (
                                /* Renderowanie dla Read Across */
                                <p className="deta-val">
                                  {prediction.report_data?.unit2ra || "N/A"}
                                </p>
                              ) : (
                                /* Renderowanie standardowe dla QSAR (mapowanie po calc_param) */
                                prediction.calc_param && Object.entries(prediction.calc_param).map(([key, value], subIdx) => (
                                  <p key={subIdx} className="deta-val">
                                    {key}
                                  </p>
                                ))
                              )}
                            </div>
                            <p className="green-head">Prediction details</p>
                            <div className="det-box no-margin-bottom">
                              <p className='grey-uppercase'>Predicted value</p>

                              <p
                                className="deta-val"
                                style={{ color: getClassColor(prediction) }}
                              >
                                {prediction.algorithm_type === "READ_ACROSS_nQTb"
                                  ? (prediction.report_data?.prediction_name || "N/A")
                                  : formatClassNotation(prediction.prediction_result, prediction.class_notations)
                                }
                              </p>
                            </div>
                            {!prediction.in_domain && (
                              <p className="out-domain-msg">
                                Prediction is out of domain
                                <br />
                                Token for this prediction has been refunded.
                              </p>
                            )}

                          </div>

                          <div className="right-lower-left-det">
                            <p className="green-head">Descriptors values</p>
                            <div className="det-box-desc">
                              <div className="deta-header">
                                <p className="grey-uppercase">Descriptor Name</p>
                                <p className="grey-uppercase">Value</p>
                              </div>

                              {/* Descriptors */}
                              {prediction.report_data?.descriptors_to_model &&
                                Object.entries(prediction.report_data.descriptors_to_model).map(([key, value], idx) => (
                                  <div key={`desc-${idx}`} className="deta-row">
                                    <span className="d-name">{key.replace(/_/g, ' ')}</span>
                                    <span className="d-val">{value}</span>
                                  </div>
                                ))}

                              {/* Cell line descriptors */}
                              {prediction.report_data?.cell_line_descr &&
                                prediction.report_data.cell_line_descr.map((item, idx) => (
                                  <div key={`cell-${idx}`} className="deta-row">
                                    <span className="d-name">{item.Label}</span>
                                    <span className="d-val">{item.Value}</span>
                                  </div>
                                ))}
                            </div>

                          </div>
                        </div>
                      )
                    ))}


                </div>


                <div className='right-details'>
                  <div className='right-details-up'>
                    <p className='green-head'>Your nanoform</p>

                    <div className='det-box max-height-nanoform'>
                      {analDetails.predictions
                        .filter(prediction => prediction.status === 'Done')
                        .map((prediction, idx) => (
                          <div key={idx}>
                            {selectedPredictionIdx === idx && (
                              <div className='prediction-details'>
                                {prediction ? (
                                  <div className='nanoform-info'>
                                    {/* Show Core only if it exists */}
                                    {prediction.nanoform && (
                                      <div className="info-row">
                                        <span className="info-key">Core</span>
                                        <span className="info-value">{prediction.nanoform}</span>
                                      </div>
                                    )}

                                    {/* Show Crystal Structure only if it exists */}
                                    {analDetails.selected_crystal_structure && (
                                      <div className="info-row">
                                        <span className="info-key">Crystal Structure</span>
                                        <span className="info-value">{analDetails.selected_crystal_structure}</span>
                                      </div>
                                    )}

                                    {/* Descriptor names and values */}
                                    {prediction.report_data?.descriptors &&
                                      Object.entries(prediction.report_data.descriptors).map(([key, value]) => (
                                        <div className="info-row" key={key}>
                                          <span className="info-key">{key.replace(/_/g, ' ')}</span>
                                          <span className="info-value">{value}</span>
                                        </div>
                                      ))}
                                  </div>
                                ) : (
                                  <p>Loading...</p>
                                )}
                              </div>
                            )}
                          </div>
                        ))}

                      <Visualization
                        core={{ name: 'TiO2' }}
                        coreModification={null}
                        coreColor="#b6b6b6"
                        surfaceFunctionalization={false}
                        surfaceFunctionalizationColor="#9ed2ff"
                        lineColor="#7fb13a"
                        isNanoformImageGenerated={false}
                        visualizationType={visualizationType}
                        height={422}
                        staticImage={false} // 👈 renders as picture, not interactive canvas
                      />


                    </div>

                  </div>

                </div>

              </div>
            </div>
          ) : (
            <p>Loading analysis details...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailsResultsAnal;
